export default __webpack_public_path__ + "static/media/Rubik-ExtraBoldItalic.0380268c.ttf";